<style scoped lang="scss">
  .wrap-reset{
    background: #F8F8F8;
    padding:40px 0;
    .container{
      background: #fff;
      width: 1000px;
      padding:40px 250px;
    }
    .title{
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 40px;
    }
  }
</style>
<style scoped>
@media screen and (max-width: 640px){
  .wrap-reset .container {
    width: 95% !important;
    padding: 10% 5% 0 0!important;
  }
  .form{
    padding-bottom: 10px;
  }
}
</style>
<template>
  <div class="wrap wrap-reset" :class="{'bg_white': showSuccess}">
    <section class="container" v-show="!showSuccess">
      <div class="title">重置密码</div>
      <el-form :model="resetForm" ref="resetForm" :rules="resetFormRules" label-width="120px" class="form">
        <el-form-item label="手机/邮箱" prop="username" required>
          <el-input v-model="resetForm.username"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="capital">
          <el-input type="text" v-model="resetForm.capital">
            <span slot="suffix" class="mr10 text-primary pointer" @click="getCode" v-if="timesCount === 0">发送验证码</span>
            <span slot="suffix" class="mr10 text-primary" v-else>{{timesCount}}s</span>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd" required>
          <el-input type="password" v-model="resetForm.newPwd" placeholder="请输入6位以上，包含数字，字母的密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmNewPwd" required>
          <el-input type="password" v-model="resetForm.confirmNewPwd" placeholder="请输入确认密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onsubmit('resetForm')">确认</el-button>
        </el-form-item>
      </el-form>
    </section>
    <div class="success" v-show="showSuccess">
      <img src="@/assets/images/icon_success.png">
      <h2>密码重置成功</h2>
      <router-link to="/login">重新登陆</router-link>
    </div>
  </div>
</template>

<script>
import { resetPassword } from '@/services/api.index'
export default {
  data () {
    let checkMobile = (rule, value, callback) => {
      if (!this.baseMethods.checkEmail(value) && !this.baseMethods.checkPhone(value)) {
        callback(new Error('请输入正确的手机/邮箱'))
      } else {
        callback()
      }
    }
    let checkPassword = (rule, value, callback) => {
      this.baseMethods.checkPasswordRules(value, callback, 'password')
    }
    let checkPasswordConfirm = (rule, value, callback) => {
      this.baseMethods.checkPasswordRules(value, callback, 'passwordConfirm')
    }
    return {
      showSuccess: false,
      resetForm: {
        username: '',
        capital: '',
        newPwd: '',
        confirmNewPwd: ''
      },
      resetFormRules: {
        username: [{ validator: checkMobile, trigger: 'blur' }],
        capital: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPwd: [{ validator: checkPassword, trigger: 'blur' }],
        confirmNewPwd: [{ validator: checkPasswordConfirm, trigger: 'blur' }]
      },
      timesCount: 0
    }
  },
  methods: {
    // 发送验证码
    getCode () {
      const { username } = this.resetForm
      if (username === '') {
        this.$refs.resetForm.validateField('username')
        return
      }
      if (username.indexOf('@') > -1) {
        this.baseMethods.sendEmailCode(username, 'resetForm', this)
      } else {
        this.baseMethods.sendCode(username, 'resetForm', this)
      }
    },
    onsubmit (formName) {
      const { username, capital, newPwd, confirmNewPwd } = this.resetForm
      if (newPwd !== confirmNewPwd) {
        this.$message.error('两次密码输入不一致')
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          resetPassword(username, capital, newPwd, confirmNewPwd).then(() => {
            this.showSuccess = true
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/reset.vue